import { useCallback } from 'react';
import { P2Alert, P2Checkbox, P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script';
import { APPLICANT_SUBMISSION_CONSENT } from '../../../config/tnc/applicant_submission_consent';
import { TncItem } from '../../../models/interfaces/terms-and-conditions.interface';

interface DeclarationProps {
  setCheckboxValue: () => void;
  checkboxValue?: boolean;
  showTitle?: boolean;
  hasPadding?: boolean;
  forceError?: boolean;
  isDisabled?: boolean;
}

function renderItems(items: TncItem[], level = 0): React.ReactNode {
  if (!items?.length) {
    return null;
  }

  const listType = level === 0 ? undefined : 'a';

  return (
    <ol type={listType} style={{ marginBottom: level === 0 ? 0 : 26 }}>
      {items.map((item) => (
        <li key={`${level}-${item.id}`} className='polymer-declaration-item'>
          <span dangerouslySetInnerHTML={{ __html: item.text }} />

          {item.note?.text && (
            <p className='mb-0 mt-2' style={{ color: '#323232' }}>
              {item.note.text}
            </p>
          )}

          {item.children && item.children.length > 0 && renderItems(item.children, level + 1)}
        </li>
      ))}
    </ol>
  );
}

function Declaration({ setCheckboxValue, checkboxValue, showTitle = true, hasPadding = true, forceError, isDisabled = false }: DeclarationProps) {
  const tnc = APPLICANT_SUBMISSION_CONSENT;

  const handleCheckbox = useCallback(() => {
    setCheckboxValue();
  }, [setCheckboxValue]);

  return (
    <div className={`polymer-declaration-container ${hasPadding ? '' : 'polymer-declaration-no-padding'}`}>
      {showTitle && (
        <div className='polymer-declaration-title'>
          <P2TextDescription color='#000' title='Declaration and Authorisation' />
        </div>
      )}

      <div className='polymer-declaration-checkbox' style={{ marginBottom: 32 }}>
        <P2Checkbox
          variant={isDisabled ? 'disabled' : 'default'}
          isActive={checkboxValue}
          onClick={handleCheckbox}
          description={<P2TextLabel label={<span className='m-0'>{tnc.content.intro}</span>} />}
        />

        {forceError && !checkboxValue && (
          <div style={{ marginTop: 12 }}>
            <P2Alert variant='danger' text='This is a required field.' />
          </div>
        )}
      </div>

      {renderItems(tnc.content.items)}

      {tnc.content.note?.text && (
        <p className='mt-4 mb-0' style={{ color: '#323232' }}>
          {tnc.content.note.text}
        </p>
      )}
    </div>
  );
}

export default Declaration;
